import React from 'react';
import { IProduktMinimal, IProduktFilters } from '../../interfaces/IProdukt';
import {cloneDeep, mergeWith, groupBy, flow, values, flatten } from 'lodash';
import { IBlockProductDisplay } from './IBlocks';
import * as stylesProductListingView from "../lists/ProductListing/ProductListingView.module.scss";
import * as stylesAddToCartButton from '../ProductWidget/AddToCartButton.module.scss';
import classnames from 'classnames';
import { GatsbyImage } from "gatsby-plugin-image";
import ButtonAction from '../ui/Buttons/ButtonAction';
import HorizontalScroll from '../ui/HorizontalScroll/HorizontalScroll';
import { filterDefaultValueToCartConfiguration } from '../ProductWidget/ProductWidgetHelper';
import { CartContext } from '../Cart/CartContext';
import AddToCartButton from '../../assets/addToCart.animated.inline.svg';

type Props = {
    products: Array<IBlockProductDisplay>;
    columnSize?: string;
}

export default function BlockProducts (props: Props) {
    const {products} = props;

    let columnSize: string = "is-one-quarter";
    if (products.length % 3 === 0) columnSize = "is-one-third";
    if (props.columnSize) columnSize = props.columnSize;

    if (products.length === 1) {
        return <BlockProductDisplay product={products[0]} />;
    }


    return <HorizontalScroll>
        <div className={classnames(["columns", "is-multiline"])}>
            {products.map((product, index) => {
                return <div key={index} className={classnames(["column", columnSize])}>
                    <BlockProductDisplay product={product} />
                </div>
            })}
        </div>
    </HorizontalScroll>
}

type PropsDisplay = {
    product: IBlockProductDisplay;
}

function BlockProductDisplay (props: PropsDisplay) {
    const data = props.product;
    const {dispatch} = React.useContext(CartContext);
    
    const [addedToCart, setAddedToCart] = React.useState<boolean>(false);
    const timeout = React.useRef(null);
    React.useEffect(() => {
        timeout.current = setTimeout(() => {
            setAddedToCart(false);
        }, 2500);

        return () => {
            clearTimeout(timeout.current);
        }
    }, [addedToCart]);

    
    let item: IProduktMinimal = data.product ? cloneDeep(data.product) : {
        name: "Kein Titel hinterlegt",
        url: null,
        kurzbeschreibung: "Keine Kurzbeschreibung hinterlegt",
        produktTyp: "aufkleber",
    }; 

    // Overwrite values if given by block configuration
    if (data.name && data.name !== null) item.name = data.name;
    if (data.url && data.url !== null) { item.url = data.url; }
    if (data.kurzbeschreibung && data.kurzbeschreibung !== null) item.kurzbeschreibung = data.kurzbeschreibung;
    if (data.produktTyp && data.produktTyp !== null) item.produktTyp = data.produktTyp;
    if (data.listenbild && data.listenbild !== null) item.listenbild = data.listenbild;
    if (data.productWidgetKey && data.productWidgetKey !== null) item.productWidgetKey = data.productWidgetKey;
    if (data.filters) {
       const filters = mergeWith(
                groupBy(item.filters, "typ"),
                groupBy(data.filters, "typ"),
                (a, b) => b === null || b === "" ? a : undefined
            );

        item.filters = flow(
            values,
            flatten,
        )(filters) as [IProduktFilters]
    } 

    const addToCart = () => {
        // generate Configuration
        const configuration = filterDefaultValueToCartConfiguration(item.filters);
        let qty = 1;
        item.filters.forEach(item => {
            if (item.typ ===  "menge") {
                qty = Number(item.defaultValue ? item.defaultValue : item.wert);
            }
        });

        setAddedToCart(true);
        dispatch({type: "ADD_PRODUCT", product: item, configuration, qty });

        setTimeout(() => {
            dispatch({type: "OPEN_MINI_CART"});
        }, 200);
    }

    return (
        <div className={stylesProductListingView.card}>
        <div>
                <figure className="image">
                    {item.listenbild?.src?.childImageSharp?.gatsbyImageData && <GatsbyImage
                        image={item.listenbild.src.childImageSharp.gatsbyImageData}
                        alt={item.listenbild.alt}
                        title={item.listenbild.alt} />}
                </figure>
        </div>
        <div className={stylesProductListingView.content}>
            <p className={classnames(["title", stylesProductListingView.headline])}>
                    {item.name}
            </p>
            <p className={stylesProductListingView.description}>{item.kurzbeschreibung}</p>
        </div>
        
        <div>
        <ButtonAction onClick={addToCart} className={stylesAddToCartButton.button} icon={addedToCart ? "none" : "arrow"}>
                {!addedToCart && <span className={stylesAddToCartButton.text}>Anfragen</span>}
                {addedToCart && <AddToCartButton height="40" className={stylesAddToCartButton.added} />}
            </ButtonAction>
        </div>
    </div>
    );
}